import * as React from "react"
import type { SVGProps } from "react"
const SvgColorPalette = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 22a10 10 0 0 1-3.87-.79 10 10 0 0 1-3.2-2.15 10 10 0 0 1-2.14-3.18A10 10 0 0 1 2 12q0-2.07.81-3.9a10 10 0 0 1 2.2-3.17 11 11 0 0 1 3.24-2.14A10 10 0 0 1 12.2 2q2 0 3.78.69a10 10 0 0 1 3.1 1.9 9 9 0 0 1 2.13 2.87 8 8 0 0 1 .79 3.59q0 2.88-1.75 4.41A6.2 6.2 0 0 1 16 17h-1.85q-.22 0-.31.13a.5.5 0 0 0-.09.27q0 .3.38.86.37.56.37 1.29 0 1.25-.69 1.85T12 22m-5.5-9A1.46 1.46 0 0 0 8 11.5 1.46 1.46 0 0 0 6.5 10 1.46 1.46 0 0 0 5 11.5 1.46 1.46 0 0 0 6.5 13m3-4A1.46 1.46 0 0 0 11 7.5 1.46 1.46 0 0 0 9.5 6 1.46 1.46 0 0 0 8 7.5 1.46 1.46 0 0 0 9.5 9m5 0A1.46 1.46 0 0 0 16 7.5 1.46 1.46 0 0 0 14.5 6 1.46 1.46 0 0 0 13 7.5 1.46 1.46 0 0 0 14.5 9m3 4a1.46 1.46 0 0 0 1.5-1.5 1.46 1.46 0 0 0-1.5-1.5 1.46 1.46 0 0 0-1.5 1.5 1.46 1.46 0 0 0 1.5 1.5M12 20q.23 0 .36-.12a.4.4 0 0 0 .14-.33q0-.34-.37-.82-.38-.48-.38-1.43 0-1.05.73-1.67a2.6 2.6 0 0 1 1.77-.63H16a4.3 4.3 0 0 0 2.83-.96Q20 13.08 20 11.05a6.4 6.4 0 0 0-2.31-5.04A8 8 0 0 0 12.2 4Q8.8 4 6.4 6.33A7.6 7.6 0 0 0 4 12q0 3.33 2.34 5.66A7.7 7.7 0 0 0 12 20" />
  </svg>
)
export default SvgColorPalette
